export const setTitle = (title: string): string => {
    document.title = `${title} - Ausmash`;
    return title;
};
